include ../../../../common/primary/select/select.mixin.pug

form.fp-card.-highlighted(autocomplete='on' @submit.prevent='confirm' data-test='payment-partner-form')
  label.fp-field
    | {{ t('paymentPartnerForm.email') }}
    input.fp-input-text(v-model='paymentPartnerForm.email' type='text' required data-test='email')
